import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";

import Home from './home/Home';
import Quiz from './quiz/Quiz';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Route path="/" exact component={Home} />
          <Route path="/quiz" component={Quiz} />
        </div>
      </Router>
    );
  }
}

export default App;
